import { useCallback } from 'react';
import { I18nManager } from 'react-native';
import i18n from './index';
import { writeStoredLang } from './detector';
import { Telemetry } from 'app/services/telemetry/Telemetry';

export function useI18n() {
    const t = i18n.t.bind(i18n);
    const lang = i18n.language;

    const changeLanguage = useCallback(async (next: 'it' | 'en') => {
        try {
            const isRTL = false;
            if (I18nManager.isRTL !== isRTL) {
                I18nManager.allowRTL(isRTL);
                I18nManager.forceRTL(isRTL);
            }
            await i18n.changeLanguage(next);
            writeStoredLang(next);
        } catch (error) {
            Telemetry.error(error as Error, {
                event: 'i18n.change_language.failed',
                domain: 'ui',
                context: { source: 'useI18n', lang: next }
            });
        }
    }, []);

    return { t, i18n, lang, changeLanguage };
}
